import { mapEntityProperties } from '@/utils/mapEntityProperties'
import  { UpdateSpinWheelBranchEntity } from '../../domain/entities/UpdateSpinWheelBranchEntity'

export class UpdateSpinWheelBranchModel extends UpdateSpinWheelBranchEntity {
  branchIds?: number[]
  constructor(dataDto: UpdateSpinWheelBranchEntity) {
    super()
    mapEntityProperties<UpdateSpinWheelBranchModel>(this, dataDto, {
      exclude: ['branchs'],
      map: {
        branchIds: dataDto.branchs?.map((branch) => branch.id)
      }
    })
  }
}
